import type { FC } from 'react'
import { memo } from 'react'

import AiAssistantButton from './components/aiAssistantButton'
import CommonButtons from './components/commonButtons'
import DetailsButton from './components/detailsButton'
import Toolbar from './components/toolbar'

import type { DomainNode } from '@app/types'

interface Props {
  node: DomainNode
}

const BasicCardToolbar: FC<Props> = ({ node }) => {
  const { strategyId } = node
  const route = `/strategy/${strategyId}/map/basicCard/${node.data.id}`

  return (
    <Toolbar strategyId={strategyId}>
      <DetailsButton path={route} />
      <AiAssistantButton node={node} />
      <CommonButtons node={node} />
    </Toolbar>
  )
}

export default memo(BasicCardToolbar)
